const weekday = [
  { value: 1, label: 'Dia Útil' },
  { value: 6, label: 'Sábado' },
];

export default weekday;
